import { Route, Routes } from "react-router-dom";
import BoomerangPrintLabels from "../components/Boomerang/BoomerangPrintLabels";

function BoomerangPageBody() {
  return (
    <>
      <Routes>
        <Route index element={<BoomerangPrintLabels />} />
      </Routes>
    </>
  );
}

export default function BoomerangPage() {
  return <BoomerangPageBody />;
}
